import { action, observable } from "mobx";
import { api, api_adm, apiOperacao } from "../../api";
import { toast } from "react-toastify";
import { toast_error } from "../../utils";

export class _MonofasicoStore {
  obs = observable({
    monofasicos: [] as any[],
    totalRows: 0 as number,
    currentPage: 1 as number,
    filter: "" as string
  })

  async handleFilter(page: number, filter: string) {
    try {
      let params = {
        filter: filter,
        page: page,
        limit: 30
      }

      let resp = await apiOperacao("legislacoes").post(`/legislacoes/monofasico/index`, params)

      this.obs.monofasicos = [];
      this.obs.totalRows = 0

      if (resp.data.itens.length > 0) {
        this.obs.monofasicos = resp.data.itens
        this.obs.totalRows = resp.data.count
      }

    } catch (ex) { }
  }

  async doSaveCreate(monofasico) {
    try {
      let resp = await api_adm.post('/api/admin/monofasico', monofasico);
      if (resp.data.ok) {

        toast.success('Monofásico criado com sucesso', {});
        await this.handleFilter(this.obs.currentPage, this.obs.filter);

      } else {
        toast.error(`Não foi possível criar Monofásico`, {});
      }
    } catch (ex) {
      toast.error(`Erro ao criar Monofasico!`, {});
    }
  }

  async handleEdit(params: any) {

    try {
      let resp = await api_adm.post(`/api/admin/monofasico/update`, params);

      if (resp.data.ok) {
        toast.success('Monofásico editado com sucesso!', {});
        await this.handleFilter(this.obs.currentPage, this.obs.filter);
      }
      else {
        toast.warning('Não foi possível editar. Tente novamente mais tarde.', {});
      }
    } catch (ex) {
      toast.error("Erro editando Monofasico!", {});
    }
  }

  async handleDelete(id: string) {
    try {
      let resp = await api_adm.delete(`/api/admin/monofasico/${id}`);
      if (resp.data.ok) {

        toast.success('Monofásico excluído', {})
        await this.handleFilter(this.obs.currentPage, this.obs.filter);

      } else {
        toast.error(`Não foi possível excluir Monofásico`, {})
      }

    } catch (ex) {
      toast.error(`Erro ao excluir Monofásico!`, {});
    }
  }

  async doSaveDuplica(monofasico) {
    try {

      let resp = await api_adm.post('/api/admin/monofasico', monofasico);

      if (resp.data.ok) {

        toast.success('Monofásico duplicado com sucesso!', {});
        await this.handleFilter(this.obs.currentPage, this.obs.filter);

      } else {
        toast.error(`Não foi possível duplicar Monofásico!`, {});
      }

    } catch (ex) {
      toast.error(`Erro ao duplicar Monofásico!`, {});
    }

  }

  async handleExport() {

    try {
      let resp = await apiOperacao("legislacoes").get('/legislacoes/monofasico/excel');

      if (resp.data.ok) {
        const linkSource = `data:application/xlsx;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = "monofasico.xlsx";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {
        toast.warning(resp.data.error, {});
      }

    } catch (ex) {

      toast_error(ex, `Erro ao exportar, tente novamente mais tarde.`);

    }

  }


}

export const MonofasicoStore = new _MonofasicoStore();